import React, { useState } from "react";
import { ETHIOPIAN_REGIONAL_CAPITALS } from "../../../constants/ethiopia";

const EMPTY_ADDRESS = {
  country: "Ethiopia",
  city: "",
  subCity: "",
  street: "",
  houseNumber: "",
  postalCode: "",
};

export default function AddressesPage() {
  const [addresses, setAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState(EMPTY_ADDRESS);
  const [showForm, setShowForm] = useState(false);

  const addAddress = () => {
    setAddresses([...addresses, newAddress]);
    setNewAddress(EMPTY_ADDRESS);
    setShowForm(false);
  };

  return (
    <div>
      <h3 className="fw-bold">Addresses</h3>
      <p className="text-muted">Manage your shipping and billing addresses.</p>

      <button
        className="btn btn-primary mt-3"
        onClick={() => setShowForm(!showForm)}
      >
        Add New Address
      </button>

      {showForm && (
        <div className="card p-3 shadow-sm mt-3">
          <div className="mb-2">
            <label className="form-label">Country</label>
            <input className="form-control" value="Ethiopia" disabled />
          </div>

          <div className="mb-2">
            <label className="form-label">City</label>
            <select
              className="form-select"
              value={newAddress.city}
              onChange={(e) =>
                setNewAddress({ ...newAddress, city: e.target.value })
              }
            >
              <option value="">-- Select City --</option>
              {ETHIOPIAN_REGIONAL_CAPITALS.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>

          {["subCity", "street", "houseNumber", "postalCode"].map((f) => (
            <input
              key={f}
              className="form-control mb-2"
              placeholder={f.replace(/([A-Z])/g, " $1")}
              value={newAddress[f]}
              onChange={(e) =>
                setNewAddress({ ...newAddress, [f]: e.target.value })
              }
            />
          ))}

          <button className="btn btn-success" onClick={addAddress}>
            Save Address
          </button>
        </div>
      )}

      <div className="mt-4">
        {addresses.length === 0 ? (
          <p>No addresses saved.</p>
        ) : (
          addresses.map((addr, i) => (
            <div key={i} className="card p-3 shadow-sm mb-3">
              <p className="mb-1 fw-semibold">{addr.city}, Ethiopia</p>
              <p className="mb-0 text-muted">
                {addr.subCity} {addr.street} {addr.houseNumber}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
